import { render } from "./IconTwitter.vue?vue&type=template&id=7b709080"
const script = {}
script.render = render

export default script